import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useEffect } from 'react';

const Layout = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div className='d-flex flex-column min-vh-100'>
            <Header />
            <main className='flex-grow-1'>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
